import React, { useState, useEffect } from "react"
import { Edit } from "../../images"
import BottomBar from "../BottomBar/bottombar"
import { http } from "utils/http"
import { apiEndPoints } from "constants/apiEndpoints"
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight"
import { useHistory } from "react-router"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "store/store"
import { toast } from "react-toastify"
import "../AssetSummary/KioskAssetSummary.css"
import { useTranslation } from "react-i18next"

const GatePass = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const assetReducer = useSelector((state: RootState) => state.assetReducer)
  const visitReducer = useSelector((state: RootState) => state.visitReducer)
  const submitSummary = () => {
    const visitId = visitReducer.visit?.id

    http
      .post(
        `${apiEndPoints.activities}${visitId}/activities`,
        {
          type: "check-in",
          mode: "kiosk"
        },
        {}
      )
      .then(() => {
        history.push("/success-kiosk")
      })
      .catch(err => toast.error(err.response.data.error))
  }
  return (
    <>
      <div className="asset-summary-wrapper container">
        <div className="accord-container-summary">
          <div className="assetSummary-header">{t("gatepass")}</div>
        </div>
        <div className="accord-wrapper">
          <div className="wrapper-column">
            <div className="kiosk-accord-container">
              <div className="asset-accord-items">
                <div className="accord-kiosk-summary-key">{t("reference")}</div>
                <div className="kiosk-input-text-show">
                  {assetReducer.asset.referenceNumber}
                </div>
              </div>
            </div>
            {gateSummaryDetails({
              GateLinkDetails: [
                {
                  key: "USDOT #",
                  name: "usdot",
                  value: assetReducer.asset.usdot,
                  maxLength: 20
                },
                {
                  key: "Company Name",
                  name: "CompanyName",
                  value: assetReducer.asset.companyName,
                  maxLength: 50
                }
              ]
            })}
            {gateSummaryDetails({
              GateLinkDetails: [
                {
                  key: "Tractor #",
                  name: "Tractor",
                  value: assetReducer.asset.tractor,
                  maxLength: 20
                },
                {
                  key: "Trailer #",
                  name: "Trailer",
                  value: assetReducer.asset.trailer,
                  maxLength: 20
                }
              ]
            })}
          </div>
          <div className="wrapper-column">
            {gateSummaryDetails({
              GateLinkDetails: [
                {
                  key: "RFID",
                  name: "RFID",
                  value: assetReducer.asset.RFIDCode,
                  maxLength: 6
                },
                {
                  key: "Equipment Type",
                  name: "Equipment Type",
                  value: assetReducer.asset.equipmentType,
                  maxLength: 20
                },
                {
                  key: "Trailer Status",
                  name: "Trailer Status",
                  value: assetReducer.asset.trailerStatus,
                  maxLength: 20
                }
              ]
            })}
          </div>
        </div>
      </div>
      <BottomBar
        text={t("check_in")}
        onClick={() => submitSummary()}
        endIcon={<KeyboardArrowRightIcon />}
      />
    </>
  )
}
interface gateSummaryDetailProps {
  GateLinkDetails: any
}

const gateSummaryDetails = (props: gateSummaryDetailProps) => {
  return (
    <>
      <div className="kiosk-accord-container" style={{ pointerEvents: "none" }}>
        {props.GateLinkDetails.map((item: any) => {
          return (
            <div className="asset-accord-items">
              <div className="accord-kiosk-summary-key">{item.key}</div>
              <div className="accord-kiosk-summary-value">
                <div>
                  <input
                    className="kiosk-input-text-show"
                    type="text"
                    name={item.name}
                    value={item.value}
                    maxLength={item.maxLength}
                  />
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </>
  )
}

export default GatePass
